import * as React from 'react';
import { translate } from 'components/translate-hoc';
import { ITranslationProps } from 'types/translation';

import { TEXT_KEYS } from './content-banner.constants';
import './content-banner.styles.less';

export const ContentBanner = (props: ITranslationProps): JSX.Element => {
    const { dangerouslyTranslateWithHTML: translateKey } = props;
    const contentTitleText: JSX.Element = translateKey(TEXT_KEYS.EVENT_TITLE);

    return (
        <div className="sitegen-content-banner">
            <h1 className="sitegen-content-banner__title">{contentTitleText}</h1>
        </div>
    );
};

export default translate()(ContentBanner);
